module.exports = __webpack_public_path__ + "static/media/12_l_Layer3_0_0.4fde4cc7.png";